<div class="info-container" fxFlex="100" fxLayout="column">
  <div fxFlex="5"></div>
  <div fxFlex="95">
    <div fxLayout="row wrap" fxLayout.lt-lg="column" fxFlexFill>
      <div fxFlex="40" fxFlex.lt-lg="100" fxFlexFill fxLayoutAlign="center center" fxFlexOrder="1" fxFlexOrder.lt-lg="2">
        <div fxFlex="70" fxFlex.lt-xl="80" fxLayout="column" fxFlexFill fxLayoutAlign="center start" fxLayoutGap="6rem" fxLayoutGap.lt-lg="1rem" >
          <h4>{{ 'startAppError' | translate }}</h4>
        </div>
        </div>
      <div fxFlex="60" fxFlex.lt-lg="100" fxLayout="column"  fxLayoutAlign="center center" fxFlexOrder="2" fxFlexOrder.lt-lg="1">
        <img src="assets/images/page-error.svg">
      </div>
    </div>
  </div>
</div>